// extracted by mini-css-extract-plugin
module.exports = {"donut":"spinner_donut__BRjsa","spin":"spinner_spin__KPq0u"};